import React from 'react';
import styled from 'styled-components';

export const TextLabel: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  color: #3c6ab4;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.5px;
`;
